import { Theme } from '@mui/material';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const useStyles = (theme: Theme) => ({
  root: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    zIndex: 1000,
    width: '100%',
    bgcolor: '#2961FD',
  },
  tabs: {
    color: '#fff',
    '& .MuiTabs-indicator': {
      display: 'none',
    },
    '& .MuiTab-root': {
      textTransform: 'none', // Adjust text transformation
      fontWeight: 500, // Change font weight
      color: 'rgba(255, 255, 255, 0.7) !important',
      height: '48px !important',
      margin: '0 !important',
      fontSize: '16px',
      minHeight: 'unset !important',
      borderRadius: '0 !important',
    },
    '& .MuiTab-root.Mui-selected': {
      backgroundColor: 'rgba(0, 0, 0, 0.12) !important',
      color: '#fff !important',
      height: '48px !important',
      maxHeight: 'unset !important',
      margin: '0 !important',
    },
  },
});

export default useStyles;
